import { useState } from "react";
import config from "../config";

export const useLoginData = (setPendingUser) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isInvalid, setIsInvalid] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const getGeolocation = () => {
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        console.warn("Geolocation not supported");
        resolve({ latitude: null, longitude: null });
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude.toString(),
            longitude: position.coords.longitude.toString(),
          });
        },
        (error) => {
          console.warn("Could not get location:", error.message);
          resolve({ latitude: null, longitude: null });
        },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 },
      );
    });
  };

  const handleSubmit = async (event, setShow2FA, onSkip2FA) => {
    event.preventDefault();
    setLoading(true);
    setIsInvalid(false);
    setErrorMessage("");

    const { latitude, longitude } = await getGeolocation();

    const credentials = {
      email: email,
      password: password,
      longitude,
      latitude,
    };

    try {
      const response = await fetch(`${config.apiUrl}/authenticate_user`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(credentials),
        credentials: "include",
      });

      const data = await response.json();

      if (response.ok) {
        setIsInvalid(false);
        setErrorMessage("");

        localStorage.setItem("access_token", data.access_token);
        localStorage.setItem("refresh_token", data.refresh_token);
        localStorage.setItem("active_user_id", data.user.id);

        const minimalUser = {
          id: data.user.id,
          user_id: data.user.user_id,
          email: data.user.email,
          company_name: data.user.company_name,
          is_active: data.user.is_active,
          organization_id: data.user.organization_id,
          is_master_admin: data.user.is_master_admin,
          is_company_admin: data.user.is_company_admin,
          can_donate: data.user.can_donate,
          can_receive: data.user.can_receive,
          tab_permissions: data.user.tab_permissions,
        };
        setPendingUser(minimalUser);

        // check if user has email - if not, skip 2FA
        const hasEmail = data.user.email && data.user.email.trim() !== "";

        setTimeout(() => {
          setLoginSuccess(true);
          if (hasEmail) {
            setShow2FA(true);
          } else {
            // skip 2FA for users without email
            onSkip2FA && onSkip2FA();
          }
          setLoading(false);
        }, 1500);

        return { success: true };
      } else {
        setIsInvalid(true);
        setLoading(false);

        if (response.status === 429) {
          setErrorMessage("Too many login attempts. Please try again later.");
        } else if (response.status >= 500) {
          setErrorMessage("Server error. Please try again later.");
        } else {
          // use the message from the backend (includes account_disabled, org_disabled, invalid_credentials)
          setErrorMessage(data.message || "Login failed. Please try again.");
        }

        console.error("Login failed:", data.message);
        return { success: false };
      }
    } catch (error) {
      console.error("Network error:", error);
      setIsInvalid(true);
      setErrorMessage(
        "Unable to connect to the server. Please check your connection or try again later.",
      );
      setLoading(false);
      return { success: false };
    }
  };

  return {
    email,
    setEmail,
    password,
    setPassword,
    isInvalid,
    passwordVisible,
    setPasswordVisible,
    loading,
    loginSuccess,
    setLoginSuccess,
    errorMessage,
    handleSubmit,
  };
};
